// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MAP COMBAT PANEL — inline map-viewport modal.
   Follows the InfectionOrb/minigame glassmorphism pattern:
   portal'd into .deck-map-area, theme-tinted backdrop,
   crimson/blue/purple etc. glass body filling the viewport.
   ============================================ */

/* Scrim — neutral dark backdrop. Matches the BottomLeftStatusRail status
   panel language: a near-solid surface with a slight blur, not a themed
   glass tint. */
.mcp-overlay {
  position: absolute;
  inset: 0;
  z-index: 100;
  container-type: inline-size;
  background: rgba(6, 4, 8, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  padding: 28px;
  animation: mcp-scrim-fade-in 0.16s ease-out;
}

@keyframes mcp-scrim-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Modal body — solid dark panel matching BottomLeftStatusRail.
   Theme only shows through the 2px left-border accent + inner chrome. */
.mcp-body {
  position: relative;
  width: 100%;
  height: 100%;
  background: rgba(10, 10, 14, 0.96);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.55);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: mcp-pop-in 0.22s cubic-bezier(0.34, 1.2, 0.5, 1);
}

@keyframes mcp-pop-in {
  from { opacity: 0; transform: scale(0.98); }
  to   { opacity: 1; transform: scale(1); }
}

/* ─── Close button (top-right) ─── */

.mcp-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 5;
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: color-mix(in srgb, var(--creature-color, #22c55e) 12%, rgba(20, 14, 26, 0.55));
  border: 1px solid color-mix(in srgb, var(--creature-color, #22c55e) 32%, transparent);
  border-radius: 8px;
  color: color-mix(in srgb, var(--creature-color, #22c55e) 85%, #fff);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.mcp-close:hover {
  background: color-mix(in srgb, var(--creature-color, #22c55e) 22%, rgba(20, 14, 26, 0.7));
  border-color: color-mix(in srgb, var(--creature-color, #22c55e) 55%, transparent);
  color: #fff;
}

/* ─── Combat header ─── */

.mcp-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 56px 14px 18px; /* right padding clears close button */
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.02);
  flex-shrink: 0;
}

.mcp-avatar {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--creature-color, #22c55e);
  filter: drop-shadow(0 0 8px color-mix(in srgb, var(--creature-color, #22c55e) 45%, transparent));
  flex-shrink: 0;
}

.mcp-avatar svg {
  width: 100%;
  height: 100%;
}

.mcp-name-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex-shrink: 0;
}

.mcp-name {
  font-size: 14px;
  font-weight: 700;
  color: var(--creature-color, #22c55e);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  line-height: 1.15;
  text-shadow: 0 0 8px color-mix(in srgb, var(--creature-color, #22c55e) 25%, transparent);
}

.mcp-trait {
  font-size: 11px;
  color: rgba(220, 220, 230, 0.65);
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

/* ─── Tray (status chips) ─── */

.mcp-tray {
  display: flex;
  gap: 8px;
  padding: 8px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: transparent;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.mcp-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  background: color-mix(in srgb, var(--creature-color, #22c55e) 8%, rgba(20, 14, 26, 0.55));
  border: 1px solid color-mix(in srgb, var(--creature-color, #22c55e) 22%, transparent);
  border-radius: 999px;
  font-size: 11px;
  color: rgba(220, 220, 230, 0.8);
  white-space: nowrap;
}

.mcp-badge--accent {
  border-color: color-mix(in srgb, var(--creature-color, #22c55e) 48%, transparent);
  color: var(--creature-color, #22c55e);
}

.mcp-badge--streak {
  border-color: rgba(251, 191, 36, 0.35);
  color: #fbbf24;
}

.mcp-badge--tokens {
  border-color: rgba(34, 197, 94, 0.35);
  color: #22c55e;
}

.mcp-badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 6px currentColor;
}

/* ─── Content area (session mounts here) ─── */

.mcp-content {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 16px;
}

/* Stub / standalone content (no embedded session) — center it for the CTA. */
.mcp-content > .mcp-stub {
  margin: auto;
}

.mcp-loading {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.mcp-loading-spinner {
  width: 44px;
  height: 44px;
  border: 3px solid rgba(255, 255, 255, 0.08);
  border-top-color: var(--accent-primary, #ef4444);
  border-radius: 50%;
  animation: mcp-loading-spin 0.8s linear infinite;
}

@keyframes mcp-loading-spin {
  to { transform: rotate(360deg); }
}

/* Embedded-session wrapper — fills the modal content area full-bleed so the
   session owns its own internal layout (card-viewport + sticky nav bar). */
.mcp-embedded-session {
  width: 100%;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* When a session is embedded, let it fill the modal body end-to-end. */
.mcp-content:has(.mcp-embedded-session) {
  overflow: hidden;
  padding: 0;
}

/* LevelSession defaults to min-height: 100vh + sticky headers. Inside the
   modal we want it to fill the embedded wrapper and own its own scroll. */
.mcp-embedded-session .ls-page,
.mcp-embedded-session .ls-card-mode,
.mcp-embedded-session .ls-pinned-nav {
  min-height: 0;
  height: 100%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: transparent;
  overflow: hidden;
}

/* Embedded session loading / generating states default to min-height: 80vh
   (or similar) which overflows the modal body so spinners land below the
   visible area. Reset to fill the embedded wrapper and center via flex. */
.mcp-embedded-session .ls-loading,
.mcp-embedded-session .ls-generating,
.mcp-embedded-session .resus-loading {
  min-height: 0;
  flex: 1 1;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  gap: var(--space-3);
}

/* Hide LevelSession's in-container header (back button, subtopic name,
   answered-count pill) — the modal chrome already owns all of that. */
.mcp-embedded-session .ls-header {
  display: none;
}

/* Question area — scrolls internally when content overflows. \`margin-top:
   auto\` on the wrapper anchors short cards to the bottom while keeping
   overflow-y: auto reachable for taller content. Content grows upward. */
.mcp-embedded-session .ls-pinned-nav .ls-card-viewport {
  flex: 1 1;
  min-height: 0;
  padding: var(--space-3) var(--space-5);
  justify-content: flex-start;
  overflow-y: auto;
}

.mcp-embedded-session .ls-card-wrapper {
  margin: auto;
  padding: var(--space-4) 0;
}

/* Trial warning — hidden when embedded. The modal chrome already signals
   the session type (trait subtitle under the header name). */
.mcp-embedded-session .ls-trial-warning {
  display: none;
}

/* Nav bar pinned to the bottom of the modal body — prev/next are always
   reachable, card-viewport scrolls above. */
.mcp-embedded-session .ls-pinned-nav .ls-nav-bar {
  flex-shrink: 0;
  background: rgba(10, 10, 14, 0.96);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: var(--space-3) var(--space-4);
}

/* Subtle crimson-style scrollbar in the theme color */
.mcp-content::-webkit-scrollbar {
  width: 6px;
}

.mcp-content::-webkit-scrollbar-track {
  background: transparent;
}

.mcp-content::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--creature-color, #22c55e) 22%, rgba(255,255,255,0.08));
  border-radius: 999px;
}

.mcp-stub {
  max-width: 480px;
  width: 100%;
  text-align: center;
  padding: 28px 24px;
  border: 1px dashed color-mix(in srgb, var(--creature-color, #22c55e) 38%, transparent);
  border-radius: 4px;
  background:
    linear-gradient(180deg,
      color-mix(in srgb, var(--creature-color, #22c55e) 6%, transparent),
      transparent);
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.mcp-stub-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--creature-color, #22c55e);
  text-shadow: 0 0 8px color-mix(in srgb, var(--creature-color, #22c55e) 30%, transparent);
}

.mcp-stub-title {
  font-size: 16px;
  font-weight: 600;
  color: #f3f4f6;
  margin: 0;
  line-height: 1.35;
}

.mcp-stub-hint {
  font-size: 12px;
  color: rgba(220, 220, 230, 0.62);
  margin: 0;
  line-height: 1.55;
  max-width: 400px;
}

.mcp-primary-btn {
  margin-top: 8px;
  padding: 10px 28px;
  background: linear-gradient(180deg,
    color-mix(in srgb, var(--creature-color, #22c55e) 95%, #fff),
    var(--creature-color, #22c55e));
  color: #0a0a10;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  cursor: pointer;
  transition: transform 0.12s ease, filter 0.12s ease, box-shadow 0.12s ease;
  box-shadow:
    0 4px 18px color-mix(in srgb, var(--creature-color, #22c55e) 40%, transparent),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.mcp-primary-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.1);
  box-shadow:
    0 8px 24px color-mix(in srgb, var(--creature-color, #22c55e) 55%, transparent),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.mcp-primary-btn:active {
  transform: translateY(0);
}

.mcp-message-body {
  margin: auto;
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}

.mcp-message-body p {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: rgba(220, 220, 230, 0.8);
}

.mcp-message-body .mcp-primary-btn {
  margin-top: 0;
}

/* Fallback when portal target isn't a map viewport (mounts to body):
   become a centered full-screen modal. */
body > .mcp-overlay {
  position: fixed;
  padding: 40px;
}

/* Mobile — close to edge, fold header */
@media (max-width: 640px) {
  .mcp-overlay { padding: 16px; }
  .mcp-header {
    flex-wrap: wrap;
    padding-right: 48px;
  }
  .mcp-name { max-width: none; }
}

@container (max-width: 720px) {
  .mcp-close {
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
    border-radius: 7px;
  }

  .mcp-header {
    gap: 10px;
    padding: 10px 48px 10px 14px;
  }

  .mcp-avatar {
    width: 36px;
    height: 36px;
  }

  .mcp-name-col {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
  }

  .mcp-name,
  .mcp-trait {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mcp-name {
    font-size: 12px;
    letter-spacing: 0.06em;
  }

  .mcp-trait {
    font-size: 10px;
    letter-spacing: 0.1em;
  }
}

@container (max-width: 480px) {
  .mcp-close {
    width: 26px;
    height: 26px;
  }

  .mcp-header {
    gap: 8px;
    padding: 9px 44px 9px 12px;
  }

  .mcp-avatar {
    width: 32px;
    height: 32px;
  }

  .mcp-name {
    font-size: 11px;
  }

  .mcp-trait {
    font-size: 9px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MapCombatPanel/MapCombatPanel.css"],"names":[],"mappings":"AAAA;;;;;iDAKiD;;AAEjD;;gBAEgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;wEACwE;AACxE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2DAA2D;AAC7D;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA,qCAAqC;;AAErC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0FAA0F;EAC1F,qFAAqF;EACrF,kBAAkB;EAClB,mEAAmE;EACnE,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,yFAAyF;EACzF,iFAAiF;EACjF,WAAW;AACb;;AAEA,0BAA0B;;AAE1B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B,EAAE,sCAAsC;EACpE,kDAAkD;EAClD,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,gGAAgG;EAChG,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wFAAwF;AAC1F;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,kDAAkD;EAClD,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yFAAyF;EACzF,qFAAqF;EACrF,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iFAAiF;EACjF,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA,+CAA+C;;AAE/C;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,SAAS;AACX;;AAEA,6EAA6E;AAC7E;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,gDAAgD;EAChD,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;2EAC2E;AAC3E;EACE,WAAW;EACX,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;0EAC0E;AAC1E;;;EAGE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;0EAE0E;AAC1E;;;EAGE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;sEACsE;AACtE;EACE,aAAa;AACf;;AAEA;;yEAEyE;AACzE;EACE,SAAO;EACP,aAAa;EACb,sCAAsC;EACtC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;6DAC6D;AAC7D;EACE,aAAa;AACf;;AAEA;4CAC4C;AAC5C;EACE,cAAc;EACd,kCAAkC;EAClC,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA,sDAAsD;AACtD;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sFAAsF;EACtF,kBAAkB;EAClB;;;kBAGgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,wFAAwF;AAC1F;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB;;mCAEiC;EACjC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,0EAA0E;EAC1E;;2CAEyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB;;0CAEwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;yCACyC;AACzC;EACE,eAAe;EACf,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,eAAe,aAAa,EAAE;EAC9B;IACE,eAAe;IACf,mBAAmB;EACrB;EACA,YAAY,eAAe,EAAE;AAC/B;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* ============================================\n   MAP COMBAT PANEL — inline map-viewport modal.\n   Follows the InfectionOrb/minigame glassmorphism pattern:\n   portal'd into .deck-map-area, theme-tinted backdrop,\n   crimson/blue/purple etc. glass body filling the viewport.\n   ============================================ */\n\n/* Scrim — neutral dark backdrop. Matches the BottomLeftStatusRail status\n   panel language: a near-solid surface with a slight blur, not a themed\n   glass tint. */\n.mcp-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 100;\n  container-type: inline-size;\n  background: rgba(6, 4, 8, 0.5);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  padding: 28px;\n  animation: mcp-scrim-fade-in 0.16s ease-out;\n}\n\n@keyframes mcp-scrim-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Modal body — solid dark panel matching BottomLeftStatusRail.\n   Theme only shows through the 2px left-border accent + inner chrome. */\n.mcp-body {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: rgba(10, 10, 14, 0.96);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.55);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: mcp-pop-in 0.22s cubic-bezier(0.34, 1.2, 0.5, 1);\n}\n\n@keyframes mcp-pop-in {\n  from { opacity: 0; transform: scale(0.98); }\n  to   { opacity: 1; transform: scale(1); }\n}\n\n/* ─── Close button (top-right) ─── */\n\n.mcp-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 5;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: color-mix(in srgb, var(--creature-color, #22c55e) 12%, rgba(20, 14, 26, 0.55));\n  border: 1px solid color-mix(in srgb, var(--creature-color, #22c55e) 32%, transparent);\n  border-radius: 8px;\n  color: color-mix(in srgb, var(--creature-color, #22c55e) 85%, #fff);\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.mcp-close:hover {\n  background: color-mix(in srgb, var(--creature-color, #22c55e) 22%, rgba(20, 14, 26, 0.7));\n  border-color: color-mix(in srgb, var(--creature-color, #22c55e) 55%, transparent);\n  color: #fff;\n}\n\n/* ─── Combat header ─── */\n\n.mcp-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 56px 14px 18px; /* right padding clears close button */\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(255, 255, 255, 0.02);\n  flex-shrink: 0;\n}\n\n.mcp-avatar {\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--creature-color, #22c55e);\n  filter: drop-shadow(0 0 8px color-mix(in srgb, var(--creature-color, #22c55e) 45%, transparent));\n  flex-shrink: 0;\n}\n\n.mcp-avatar svg {\n  width: 100%;\n  height: 100%;\n}\n\n.mcp-name-col {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.mcp-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--creature-color, #22c55e);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  line-height: 1.15;\n  text-shadow: 0 0 8px color-mix(in srgb, var(--creature-color, #22c55e) 25%, transparent);\n}\n\n.mcp-trait {\n  font-size: 11px;\n  color: rgba(220, 220, 230, 0.65);\n  line-height: 1;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n}\n\n/* ─── Tray (status chips) ─── */\n\n.mcp-tray {\n  display: flex;\n  gap: 8px;\n  padding: 8px 18px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  background: transparent;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.mcp-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 10px;\n  background: color-mix(in srgb, var(--creature-color, #22c55e) 8%, rgba(20, 14, 26, 0.55));\n  border: 1px solid color-mix(in srgb, var(--creature-color, #22c55e) 22%, transparent);\n  border-radius: 999px;\n  font-size: 11px;\n  color: rgba(220, 220, 230, 0.8);\n  white-space: nowrap;\n}\n\n.mcp-badge--accent {\n  border-color: color-mix(in srgb, var(--creature-color, #22c55e) 48%, transparent);\n  color: var(--creature-color, #22c55e);\n}\n\n.mcp-badge--streak {\n  border-color: rgba(251, 191, 36, 0.35);\n  color: #fbbf24;\n}\n\n.mcp-badge--tokens {\n  border-color: rgba(34, 197, 94, 0.35);\n  color: #22c55e;\n}\n\n.mcp-badge-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n  box-shadow: 0 0 6px currentColor;\n}\n\n/* ─── Content area (session mounts here) ─── */\n\n.mcp-content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 8px 24px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  gap: 16px;\n}\n\n/* Stub / standalone content (no embedded session) — center it for the CTA. */\n.mcp-content > .mcp-stub {\n  margin: auto;\n}\n\n.mcp-loading {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.mcp-loading-spinner {\n  width: 44px;\n  height: 44px;\n  border: 3px solid rgba(255, 255, 255, 0.08);\n  border-top-color: var(--accent-primary, #ef4444);\n  border-radius: 50%;\n  animation: mcp-loading-spin 0.8s linear infinite;\n}\n\n@keyframes mcp-loading-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Embedded-session wrapper — fills the modal content area full-bleed so the\n   session owns its own internal layout (card-viewport + sticky nav bar). */\n.mcp-embedded-session {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* When a session is embedded, let it fill the modal body end-to-end. */\n.mcp-content:has(.mcp-embedded-session) {\n  overflow: hidden;\n  padding: 0;\n}\n\n/* LevelSession defaults to min-height: 100vh + sticky headers. Inside the\n   modal we want it to fill the embedded wrapper and own its own scroll. */\n.mcp-embedded-session .ls-page,\n.mcp-embedded-session .ls-card-mode,\n.mcp-embedded-session .ls-pinned-nav {\n  min-height: 0;\n  height: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: transparent;\n  overflow: hidden;\n}\n\n/* Embedded session loading / generating states default to min-height: 80vh\n   (or similar) which overflows the modal body so spinners land below the\n   visible area. Reset to fill the embedded wrapper and center via flex. */\n.mcp-embedded-session .ls-loading,\n.mcp-embedded-session .ls-generating,\n.mcp-embedded-session .resus-loading {\n  min-height: 0;\n  flex: 1;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  gap: var(--space-3);\n}\n\n/* Hide LevelSession's in-container header (back button, subtopic name,\n   answered-count pill) — the modal chrome already owns all of that. */\n.mcp-embedded-session .ls-header {\n  display: none;\n}\n\n/* Question area — scrolls internally when content overflows. `margin-top:\n   auto` on the wrapper anchors short cards to the bottom while keeping\n   overflow-y: auto reachable for taller content. Content grows upward. */\n.mcp-embedded-session .ls-pinned-nav .ls-card-viewport {\n  flex: 1;\n  min-height: 0;\n  padding: var(--space-3) var(--space-5);\n  justify-content: flex-start;\n  overflow-y: auto;\n}\n\n.mcp-embedded-session .ls-card-wrapper {\n  margin: auto;\n  padding: var(--space-4) 0;\n}\n\n/* Trial warning — hidden when embedded. The modal chrome already signals\n   the session type (trait subtitle under the header name). */\n.mcp-embedded-session .ls-trial-warning {\n  display: none;\n}\n\n/* Nav bar pinned to the bottom of the modal body — prev/next are always\n   reachable, card-viewport scrolls above. */\n.mcp-embedded-session .ls-pinned-nav .ls-nav-bar {\n  flex-shrink: 0;\n  background: rgba(10, 10, 14, 0.96);\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  padding: var(--space-3) var(--space-4);\n}\n\n/* Subtle crimson-style scrollbar in the theme color */\n.mcp-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.mcp-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.mcp-content::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--creature-color, #22c55e) 22%, rgba(255,255,255,0.08));\n  border-radius: 999px;\n}\n\n.mcp-stub {\n  max-width: 480px;\n  width: 100%;\n  text-align: center;\n  padding: 28px 24px;\n  border: 1px dashed color-mix(in srgb, var(--creature-color, #22c55e) 38%, transparent);\n  border-radius: 4px;\n  background:\n    linear-gradient(180deg,\n      color-mix(in srgb, var(--creature-color, #22c55e) 6%, transparent),\n      transparent);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n}\n\n.mcp-stub-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--creature-color, #22c55e);\n  text-shadow: 0 0 8px color-mix(in srgb, var(--creature-color, #22c55e) 30%, transparent);\n}\n\n.mcp-stub-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #f3f4f6;\n  margin: 0;\n  line-height: 1.35;\n}\n\n.mcp-stub-hint {\n  font-size: 12px;\n  color: rgba(220, 220, 230, 0.62);\n  margin: 0;\n  line-height: 1.55;\n  max-width: 400px;\n}\n\n.mcp-primary-btn {\n  margin-top: 8px;\n  padding: 10px 28px;\n  background: linear-gradient(180deg,\n    color-mix(in srgb, var(--creature-color, #22c55e) 95%, #fff),\n    var(--creature-color, #22c55e));\n  color: #0a0a10;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  cursor: pointer;\n  transition: transform 0.12s ease, filter 0.12s ease, box-shadow 0.12s ease;\n  box-shadow:\n    0 4px 18px color-mix(in srgb, var(--creature-color, #22c55e) 40%, transparent),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n}\n\n.mcp-primary-btn:hover {\n  transform: translateY(-1px);\n  filter: brightness(1.1);\n  box-shadow:\n    0 8px 24px color-mix(in srgb, var(--creature-color, #22c55e) 55%, transparent),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n}\n\n.mcp-primary-btn:active {\n  transform: translateY(0);\n}\n\n.mcp-message-body {\n  margin: auto;\n  max-width: 520px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.mcp-message-body p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.6;\n  color: rgba(220, 220, 230, 0.8);\n}\n\n.mcp-message-body .mcp-primary-btn {\n  margin-top: 0;\n}\n\n/* Fallback when portal target isn't a map viewport (mounts to body):\n   become a centered full-screen modal. */\nbody > .mcp-overlay {\n  position: fixed;\n  padding: 40px;\n}\n\n/* Mobile — close to edge, fold header */\n@media (max-width: 640px) {\n  .mcp-overlay { padding: 16px; }\n  .mcp-header {\n    flex-wrap: wrap;\n    padding-right: 48px;\n  }\n  .mcp-name { max-width: none; }\n}\n\n@container (max-width: 720px) {\n  .mcp-close {\n    top: 10px;\n    right: 10px;\n    width: 28px;\n    height: 28px;\n    border-radius: 7px;\n  }\n\n  .mcp-header {\n    gap: 10px;\n    padding: 10px 48px 10px 14px;\n  }\n\n  .mcp-avatar {\n    width: 36px;\n    height: 36px;\n  }\n\n  .mcp-name-col {\n    flex: 1 1 auto;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .mcp-name,\n  .mcp-trait {\n    display: block;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .mcp-name {\n    font-size: 12px;\n    letter-spacing: 0.06em;\n  }\n\n  .mcp-trait {\n    font-size: 10px;\n    letter-spacing: 0.1em;\n  }\n}\n\n@container (max-width: 480px) {\n  .mcp-close {\n    width: 26px;\n    height: 26px;\n  }\n\n  .mcp-header {\n    gap: 8px;\n    padding: 9px 44px 9px 12px;\n  }\n\n  .mcp-avatar {\n    width: 32px;\n    height: 32px;\n  }\n\n  .mcp-name {\n    font-size: 11px;\n  }\n\n  .mcp-trait {\n    font-size: 9px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
